import "core-js/es6/map";
import "core-js/es6/set";
import "core-js/es6/promise";
import "core-js/fn/object/assign";
import "core-js/fn/string/includes";

import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "ion-rangeslider/css/ion.rangeSlider.min.css";
import "icheck/skins/flat/green.css";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import AppBoot from "./AppLoader";
import "jquery";
import $ from "jquery";

function x() {
	const originalFetch = window.fetch;
	window.fetch = async function ( ...args ) {
		let [ resource, config ] = args as any;
		if ( resource.includes( "meta.json" ) ) {
			const timestamp = Date.now();
			const url = resource + `?t=${ timestamp }`;
			config = config || {};
			config.headers = {
				...config.headers,
				"Cache-Control": "no-cache",
			};
			return originalFetch( url, config );
		}
		return originalFetch( ...args );
	};
}

x();

const w = window as any;
const g = global as any;
w.jQuery = w.$ = $;
g.jQuery = require( "jquery" );
const dataTableScript = document.createElement( "script" );
const dataTableSelectScript = document.createElement( "script" );
const dataTableResponsiveScript = document.createElement( "script" );
dataTableScript.src = "https://cdn.datatables.net/2.1.8/js/dataTables.js";
dataTableScript.onload = () => {
	document.body.appendChild( dataTableSelectScript );
};
dataTableSelectScript.src = "https://cdn.datatables.net/select/2.1.0/js/dataTables.select.min.js";
dataTableResponsiveScript.src = "https://cdn.datatables.net/responsive/3.0.3/js/responsive.dataTables.js";
document.body.appendChild( dataTableScript );
require( "bootstrap" );
require( "jquery-knob" );
require( "ion-rangeslider" );
require( "icheck" );
ReactDOM.render( <AppBoot/>, document.getElementById( "root" ) );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
declare var module: any;
if ( module.hot ) {
	module.hot.accept();
}
